import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
    loginData: Cookies.get('loginData') ? JSON.parse(Cookies.get('loginData')) : null,
    token: Cookies.get('token') ? Cookies.get('token') : null,
    isLoading: false,
    error: null
}

export const user_information = createSlice({
    name: "user",
    initialState,
    reducers: {
        setLoginData(state, action) {
            state.loginData = action.payload.admin;
            state.token = action.payload.token;
            Cookies.set('loginData', JSON.stringify(action.payload.admin));
            Cookies.set('token', action.payload.token);
            console.log("action.payload : ",action.payload)
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        },
        setError(state, action) {
            state.error = action.payload;
        },
        logout(state) {
            state.loginData = null;
            state.token = null;
            state.error = null;
            Cookies.remove('loginData');
            Cookies.remove('token');
        }
    }
});

export const { setLoginData, setLoading, setError, logout } = user_information.actions;
export default user_information.reducer;